import React, { useEffect, useState } from "react";
import { useOutletContext } from "react-router-dom";
import { formatToZMW, sumOfArray } from "../../../helpers";

const BalanceSheet = ({ rdata }) => {
  const [totalAssets, setTotalAssets] = useState(0);
  const [totalLiabilitiesEquity, setTotalLiabilitiesEquity] = useState(0);
  const [rows, setRows] = useState([]);
  const sumArray = (arr) => arr.reduce((sum, num) => sum + num, 0);
  useEffect(() => {
    displayBalanceSheet();
  }, []);

  const allData = useOutletContext();

  const displayBalanceSheet = () => {
    let assets = 0;
    let liabilitiesEquity = 0;
    const tableRows = [];

    tableRows.push(
        <tr className="bg-blue-900 font-bold text-white" key="fixed-assets">
          <td className="px-4 py-3 border-b border-gray-300">Assets</td>
          <td className="px-4 py-3 border-b border-gray-300">Amount</td>
          <td className="px-4 py-3 border-b border-gray-300"></td>
          <td className="px-4 py-3 border-b border-gray-300"></td>
        </tr>
      );

    // Fixed Assets
    tableRows.push(
      <tr className="bg-gray-200 font-bold" key="fixed-assets">
        <td className="px-4 py-3 border-b border-gray-300">Fixed Assets</td>
        <td className="px-4 py-3 border-b border-gray-300"></td>
        <td className="px-4 py-3 border-b border-gray-300"></td>
        <td className="px-4 py-3 border-b border-gray-300"></td>
      </tr>
    );

    rdata.supplier
      .filter((a) => a.type == 1)
      .forEach((res) => {
        const coa = allData.budget.find((b) => b.id === res.coa).coa
        if (coa.substring(0, 2) == "31") {
          const amount = parseFloat(res.amount);
          tableRows.push(
            <tr key={`fixed-asset-${res.coa}`}>
              <td className="px-4 py-3 border-b border-gray-300">{allData.coa.find((b) => b.account === coa).name}</td>
              <td className="px-4 py-3 border-b border-gray-300">{formatToZMW(amount)}</td>
              <td className="px-4 py-3 border-b border-gray-300"></td>
              <td className="px-4 py-3 border-b border-gray-300"></td>
            </tr>
          );

          assets += amount;
        }
      });

    // Current Assets
    tableRows.push(
      <tr className="bg-gray-200 font-bold" key="current-assets">
        <td className="px-4 py-3 border-b border-gray-300">Current Assets</td>
        <td className="px-4 py-3 border-b border-gray-300"></td>
        <td className="px-4 py-3 border-b border-gray-300"></td>
        <td className="px-4 py-3 border-b border-gray-300"></td>
      </tr>
    );
    rdata.supplier
      .filter((a) => a.type == 1)
      .forEach((res) => {
        const coa = allData.budget.find((b) => b.id === res.coa).coa
        if (coa.substring(0, 2) == "32") {
          const amount = parseFloat(res.amount);
          tableRows.push(
            <tr key={`current-asset-${res.coa}`}>
              <td className="px-4 py-3 border-b border-gray-300">{allData.coa.find((b) => b.account === coa).name}</td>
              <td className="px-4 py-3 border-b border-gray-300">{formatToZMW(amount)}</td>
              <td className="px-4 py-3 border-b border-gray-300"></td>
              <td className="px-4 py-3 border-b border-gray-300"></td>
            </tr>
          );
          assets += amount;
        }
      });
      const totalBills = sumArray(rdata.bills.map((res) => parseFloat(res.amount)));
      tableRows.push(
        <tr key="dca">
          <td className="px-4 py-3 border-b border-gray-300">Debtors Control Account</td>
          <td className="px-4 py-3 border-b border-gray-300">{formatToZMW(totalBills - rdata.recs[0]?.amount || 0)}</td>
          <td className="px-4 py-3 border-b border-gray-300"></td>
          <td className="px-4 py-3 border-b border-gray-300"></td>
        </tr>
      );
      assets += totalBills - rdata.recs[0]?.amount
    // Add Cash
    const cash = parseFloat(rdata.cash[0].difference);
    tableRows.push(
      <tr key="cash">
        <td className="px-4 py-3 border-b border-gray-300">Cash</td>
        <td className="px-4 py-3 border-b border-gray-300">{formatToZMW(cash)}</td>
        <td className="px-4 py-3 border-b border-gray-300"></td>
        <td className="px-4 py-3 border-b border-gray-300"></td>
      </tr>
    );
    assets += cash;
    
    setTotalAssets(assets);
    
    tableRows.push(
        <tr className="bg-gray-800 font-bold text-white" key="fixed-assets">
          <td className="px-4 py-3 border-b border-gray-300">Total Assets</td>
          <td className="px-4 py-3 border-b border-gray-300">{formatToZMW(assets)}</td>
          <td className="px-4 py-3 border-b border-gray-300"></td>
          <td className="px-4 py-3 border-b border-gray-300"></td>
        </tr>
      );
    tableRows.push(
        <tr className="bg-blue-900 font-bold text-white" key="fixed-assets">
          <td className="px-4 py-3 border-b border-gray-300">Liabilities</td>
          <td className="px-4 py-3 border-b border-gray-300">Amount</td>
          <td className="px-4 py-3 border-b border-gray-300"></td>
          <td className="px-4 py-3 border-b border-gray-300"></td>
        </tr>
      );
    // Liabilities
    const totalCredit = sumArray(rdata.supplier.filter((a) => a.type == 1).map((res) => parseFloat(res.amount)));
    const totalCred = totalCredit - sumArray(rdata.supplier.filter((a) => a.type == 2).map((res) => parseFloat(res.amount)))
    tableRows.push(
      <tr key="liabilities">
        <td className="px-4 py-3 border-b border-gray-300">Creditors Control Account</td>
        <td className="px-4 py-3 border-b border-gray-300">{formatToZMW(totalCred)}</td>
      </tr>
    );
    liabilitiesEquity += totalCred;

    setTotalLiabilitiesEquity(liabilitiesEquity);
    tableRows.push(
        <tr className="bg-gray-800 font-bold text-white" key="fixed-assets">
          <td className="px-4 py-3 border-b border-gray-300">Total Liabilities</td>
          <td className="px-4 py-3 border-b border-gray-300">{formatToZMW(liabilitiesEquity)}</td>
          <td className="px-4 py-3 border-b border-gray-300"></td>
          <td className="px-4 py-3 border-b border-gray-300"></td>
        </tr>
      );

      const rev = sumArray(rdata.bills.map((res)=>parseFloat(res.amount)))
      let exp = 0
      rdata.supplier
      .filter((a) => a.type == 1)
      .forEach((res) => {  
      const coa = allData.budget?.find((b) => b.id === res.coa)?.coa;
      
      if(coa[0] == 2){
          const amount = parseFloat(res.amount);
          exp += amount;
      }
      });

      tableRows.push(
        <tr className="bg-blue-900 font-bold text-white" key="fixed-assets">
          <td className="px-4 py-3 border-b border-gray-300">Equity</td>
          <td className="px-4 py-3 border-b border-gray-300">Amount</td>
          <td className="px-4 py-3 border-b border-gray-300"></td>
          <td className="px-4 py-3 border-b border-gray-300"></td>
        </tr>
      );

      tableRows.push(
        <tr className="" key="fixed-assets">
          <td className="px-4 py-3 border-b border-gray-300">Surplus(Deficit)</td>
          <td className="px-4 py-3 border-b border-gray-300">{formatToZMW(rev - exp)}</td>
          <td className="px-4 py-3 border-b border-gray-300"></td>
          <td className="px-4 py-3 border-b border-gray-300"></td>
        </tr>
      );

      tableRows.push(
        <tr className="" key="fixed-assets">
          <td className="px-4 py-3 border-b border-gray-300">Returned Revenue</td>
          <td className="px-4 py-3 border-b border-gray-300">0</td>
          <td className="px-4 py-3 border-b border-gray-300"></td>
          <td className="px-4 py-3 border-b border-gray-300"></td>
        </tr>
      );

      tableRows.push(
        <tr className="" key="fixed-assets">
          <td className="px-4 py-3 border-b border-gray-300">Revaluation and Reserves</td>
          <td className="px-4 py-3 border-b border-gray-300">0</td>
          <td className="px-4 py-3 border-b border-gray-300"></td>
          <td className="px-4 py-3 border-b border-gray-300"></td>
        </tr>
      );

      tableRows.push(
        <tr className="bg-gray-800 font-bold text-white" key="fixed-assets">
          <td className="px-4 py-3 border-b border-gray-300">Total Equity</td>
          <td className="px-4 py-3 border-b border-gray-300">{formatToZMW(rev - exp)}</td>
          <td className="px-4 py-3 border-b border-gray-300"></td>
          <td className="px-4 py-3 border-b border-gray-300"></td>
        </tr>
      );

    setRows(tableRows);
  };

  return (
    <div className="w-full min-h-[500px] h-full rounded-md p-3">
      <div className="container mx-auto p-4">
        <h1 className="text-2xl font-bold mb-4">Balance Sheet</h1>
        <table id="balance-sheet" className="w-full g-table">
          <tbody>{rows}</tbody>
        </table>
      </div>
    </div>
  );
};

export default BalanceSheet;
